
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RefStatus"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num_referred"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usd_earned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rank"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"fragment RefStatus on RefStatus {\n  ref_code\n  num_referred\n  usd_earned\n  rank\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
